const currencyCode = {
  USD: '$', // US
  EUR: '€', // EU
  GBP: '£', // GB
};

export default currencyCode;
